import React from 'react';
import { motion } from 'framer-motion';
import { Film, Play } from 'lucide-react';
import { BeforeAfterSlider } from './BeforeAfterSlider';
export function LutsShowcase() {
  return <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-138">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="flex flex-col items-center mb-12" data-id="element-139">
        <div className="flex items-center space-x-3 mb-4" data-id="element-140">
          <Film className="w-6 h-6 text-primary" data-id="element-141" />
          <h2 className="text-xl md:text-2xl font-black uppercase tracking-widest" data-id="element-142">
            POSTPRODUCCIÓN DE NIVEL CINE (LUTS)
          </h2>
        </div>
        <div className="w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-primary/50 to-transparent" data-id="element-143"></div>
      </motion.div>

      {/* Before/After Comparison Slider */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} viewport={{
      once: true
    }} className="mb-12 max-w-4xl mx-auto" data-id="element-144">
        <BeforeAfterSlider data-id="element-145" />
      </motion.div>
    </section>;
}